// React
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
// Styles
import useStyles from './ImagePlaceholder.style';
// Components
import Conditional from '../common/conditional';
import DefaultImage from './DefaultImage';

const ImagePlaceholder = ({ classes, src }) => {
  const [error, setError] = useState(false);
  const componentClasses = useStyles();

  useEffect(() => {
    setError(false);
  }, [src]);

  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <Conditional if={error}>
        <DefaultImage />
      </Conditional>
      <Conditional if={!error}>
        <img
          src={src}
          alt=''
          className={classNames(componentClasses.img, classes.img)}
          onError={() => setError(true)}
        />
      </Conditional>
    </div>
  );
};

ImagePlaceholder.defaultProps = {
  classes: {},
};

export default ImagePlaceholder;
